import React from 'react';
import { useNavigate } from 'react-router-dom';
import { USER_ROUTES, IB_ROUTES } from '../../constants/routeConstants';
import { Button } from '../ui';

export type SidebarMode = 'user' | 'ib';

interface SidebarToggleProps {
  mode: SidebarMode;
  onModeChange: (mode: SidebarMode) => void;
}

const SidebarToggle = ({ mode, onModeChange }: SidebarToggleProps) => {
  const navigate = useNavigate();

  const handleClientClick = () => {
    onModeChange('user');
    navigate(USER_ROUTES.USER_DASHBOARD);
  };

  const handleIBClick = () => {
    onModeChange('ib');
    navigate(IB_ROUTES.USER_IB_DASHBOARD);
  };

  return (
    <div className="px-3 pb-2 pt-4">
      <div className="flex gap-2">
        <Button
          onClick={handleClientClick}
          className={`flex-1 flex items-center justify-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
            mode === 'user'
              ? 'bg-blue-600 text-white'
              : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
          }`}
        >
          Client
        </Button>
        <Button
          onClick={handleIBClick}
          className={`flex-1 flex items-center justify-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
            mode === 'ib'
              ? 'bg-blue-600 text-white'
              : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
          }`}
        >
          IB
        </Button>
      </div>
    </div>
  );
};

export default SidebarToggle;
